<template>
    <div class="select-dom">
        <div class="select-area-div">
            <ul class="select-ul">
                <li class="title-part">
                    <span tkey="語言切換">{{i18n.tkey("lang_language_toggle")}}</span>
                </li>

                <li class="content-part">
                    <langSelect :size="'large'" :confirmFlag="confirmTag" />
                </li>

                <li class="operation-box">
                    <optionButton class="click-btn" @click="clickSubmit" tkey="關閉">{{i18n.tkey("lang_close")}}</optionButton>
                </li>
            </ul>
        </div>
    </div>
</template>

<script setup>
    import {inject, ref, onMounted} from "vue";
    import optionButton from "@/components/Shopopee3D/ui/optionButton"
    import langSelect from "@/components/shopopee/common/langSelect"

    const props = defineProps(["confirmFlag"])
    const emits = defineEmits(["save-complete"])

    const i18n = inject("i18n")
    const confirmTag = ref(false)

    function clickSubmit(){
        emits("save-complete")
    }

    onMounted(() => {
        if (null != props.confirmFlag){
            confirmTag.value = props.confirmFlag
        }
    })

</script>

<style scoped>
    .select-dom {
        position: absolute;
        z-index: 400;
        width: 100%;
        height: 100%;
        background: #00000091;
        display: flex;
        left: 0;
        top: 0;
        align-items: center;
        justify-content: center;
    }

    @media screen and (min-width: 520px) {
        .select-dom .select-area-div {
            width: 50%;
            height: 50%;
            padding: 20px;
            border-radius: 15px;
            background: #fefefe;
            font-size: 18px;
            color: #4e486d;
            font-weight: 800;
            user-select: none;

            box-sizing: border-box;
        }
    }

    @media screen and (max-width: 520px) {
        .select-dom .select-area-div {
            width: 85%;
            height: 80%;
            padding: 10px;
            border-radius: 15px;
            background: #fefefe;
            font-size: 18px;
            color: #4e486d;
            font-weight: 800;
            user-select: none;

            box-sizing: border-box;
        }
    }

    .select-ul {
        width: 100%;
        height: 100%;
        list-style: none;
        padding-left: 0;
        margin-bottom: 0;
        margin-top: 0;
    }

    .btn-group-box {
        display: flex;
    }

    .title-part {
        height: 30px;
    }

    .operation-box {
        height: 50px;
        text-align: center;
    }

    .content-part {
        height: calc(100% - 80px);
        box-sizing: border-box;
        padding-top: 20px;
        padding-bottom: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .click-btn {
        width: 150px;
    }

    .btn-box {
        display: inline-block;
    }
</style>